module.exports = require('./helpers/bundle-url').getBundleURL('filTu') + "logo.c51670a8.svg";